export default function NavbarMobile() {
  let mobileNavLink = document.querySelectorAll(".navbar-mobile_item-link");
  let mobileNavDropDownLink = document.querySelectorAll(
    ".navbar-mobile_dropdown-link"
  );
  let backBtn = document.querySelectorAll(".nav-item-back-btn");
  let dropdownContent = document.querySelectorAll(".dropdown-content");
  let level2 = document.querySelectorAll(".level-2");
  let level3 = document.querySelectorAll(".level-3");

  let primaryMenu = document.querySelector(".navbar-mobile_primary-menu");
  let submenu = document.querySelectorAll(".navbar-mobile_submenu");

  let toggle = (prop) => {
    for (let i of submenu) {
      if (i.id === prop) {
        primaryMenu.classList.remove("show");
        primaryMenu.classList.add("hide");
        i.classList.remove("hide");
        i.classList.add("show");
      }
    }
  };

  for (let i of mobileNavLink) {
    i.addEventListener("click", (e) => {
      toggle(e.target.getAttribute("data-id"));
    });
  }

  for (let i of backBtn) {
    i.addEventListener("click", (e) => {
      for (let i of mobileNavDropDownLink) {
        i.parentNode.classList.remove("focus", "arrow-down");
      }
      primaryMenu.classList.remove("hide");
      primaryMenu.classList.add("show");

      submenu.forEach((element) => {
        element.classList.remove("show");
        element.classList.add("hide");
      });

      level2.forEach((element) => {
        element.classList.remove("focus");
      });

      level3.forEach((element) => {
        element.classList.add("hide");
      });

      dropdownContent.forEach((element) => {
        element.classList.add("hide");
      });

      mobileNavDropDownLink.forEach((element) => {
        element.classList.remove("focus");
      });
    });
  }

  for (let i of mobileNavDropDownLink) {
    i.addEventListener("click", (e) => {
      if (e.target.classList.contains("level-2-link")) {
        if (e.target.parentNode.classList.contains("focus")) {
          e.target.parentNode.classList.remove("focus", "arrow-down");
        } else {
          for (let i of mobileNavDropDownLink) {
            i.parentNode.classList.remove("focus", "arrow-down");
          }

          e.target.parentNode.classList.add("focus", "arrow-down");
        }

        let dataId = e.target.getAttribute("data-id");

        for (let i of level3) {
          if (i.id === dataId) {
            if (i.classList.contains("hide")) {
              i.classList.remove("hide");
            } else {
              i.classList.add("hide");
            }
          } else {
            i.classList.add("hide");
          }
        }
      } else if (e.target.classList.contains("navbar-mobile_dropdown-link")) {
        let dataIdLevel3 = e.target.getAttribute("data-id");
        for (let i of dropdownContent) {
          if (i.id === dataIdLevel3) {
            if (i.classList.contains("hide")) {
              i.classList.remove("hide");
            } else {
              i.classList.add("hide");
            }
          } else {
            i.classList.add("hide");
          }
        }
      }
    });
  }
}
